import { mapActions, mapGetters, mapMutations } from 'vuex'

export const rfvAnalysis = {
  props: {},

  data: () => ({}),

  computed: {
    ...mapGetters([
      'currentPeriod',
      'referencePeriod',
      'analyticAllPeriods',
      'analyticsConfiguration',
      'referenceClientsMetrics',
      'currentClientsMetrics',
      'periodMigrations',
      'minAnalyticPeriod',
      'maxAnalyticPeriod',
      'rfvAnalyticConfigurations',
    ]),
    clientTypesToSegmentCluster() {
      return {
        champions: 'champions',
        loyals: 'loyals',
        promising: 'promising',
        atRisk: 'at_risk',
        lowValue: 'low_value',
        losses: 'losses',
        neverBought: 'never_bought',
      }
    },
  },

  methods: {
    ...mapMutations(['SET_ANALYTICS_CONFIGURATION', 'SET_ANALYTICS_CONFIGURATIONS', 'SET_CLIENTS_METRICS', 'SET_PERIOD_MIGRATIONS']),
    ...mapActions([
      'getAnalyticsConfiguration',
      'getAllAnalyticPeriods',
      'getClientsMetrics',
      'getPeriodMigrations',
      'setCurrentPeriod',
      'setReferencePeriod',
      'getAnalyticsConfigurations',
    ]),
  },
}
